import {useParams, useRouteMatch} from 'react-router-dom';
import {SeniorCaregiversListing} from '../../../../../../../components/senior-caregivers-listing/senior-caregivers-listing';
import {useOffice} from '../../../../../../../contexts/office/context';
import {CaregiverMode} from '../../../../../../../enums';

export default function SeniorInformalCaregiversProfessionalCaregiverOfficeScreen() {
  let {id, entityId}: {id: string; entityId: string} = useParams();
  const officeContext = useOffice();
  let {url} = useRouteMatch();

  return (
    <SeniorCaregiversListing
      seniorId={id || ''}
      seniorName={
        officeContext.state.userForm?.user.displayName ||
        officeContext.state.userForm?.user.name ||
        ''
      }
      invitesHistoryUrl={url.charAt(url.length - 1) === '/' ? `${url}invites` : `${url}/invites`}
      inviteCaregiverUrl={url.charAt(url.length - 1) === '/' ? `${url}invite` : `${url}/invite`}
      caregiverMode={CaregiverMode.Professional}
      url={url}
      entityId={entityId}
    />
  );
}
